import React from 'react';
import PropTypes from 'prop-types';
import { ErrorList } from './style';

const FieldErrors = ({ errors, error }) => (
    <ErrorList>
      {errors.length > 0 && errors.map(err => <span>{err}</span>)}
      {error && <span>{error}</span>}
    </ErrorList>
  );

FieldErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  error: PropTypes.string,
};

FieldErrors.defaultProps = {
  errors: [],
  error: '',
};

export default FieldErrors;
